import React from "react";
import { ToDoList } from "./Container/ToDoList";

const App = () => {
return (
  <div>
    <ToDoList/>
  </div>
)
}

export default App 